import { getPacvueTokenFromLocalStorage } from "./pacvueTokenStore";
export const PacvueTokenHttpHeaderName = "x-pacvue-token";
export async function getPacvueAuthorizationHeader(accountId) {
    const token = await getPacvueTokenFromLocalStorage(accountId);
    return token ? { [PacvueTokenHttpHeaderName]: `Bearer ${token.pacvueToken}` } : {};
}
